import React, { useState } from "react";
import { AnnsModal, Col, ConfirmationAlert, Row } from "../../../components/Component";
import moment from "moment";
import { timesheetCancel } from "../timesheets/TimesheetData";
import { RotaOptions, dateToShow, showErrorToast, showSuccessToast } from "../../../utils";
import QueryModal from "../timesheets/QueryModal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { RotaCopyJob } from "./Rotas";
import { trainingCancelAPI } from "./RotaTableData";

export const ModalStatus = {
  success: "success",
  pending: "pending",
};

const RotaDetailModal = ({ visible, dayLabel, item, onSaved, onClosed, rotaStatus }) => {
  const history = useHistory();
  const [queryModal, setQueryModal] = useState(false);
  const isTraining = item?.isTraining;

  const close = (result) => {
    onClosed(result);
  };

  const onCancelRota = () => {
    setQueryModal(true);
  };

  const onEditTraining = () => {
    history.push(`${process.env.PUBLIC_URL}/add-job`, {
      type: RotaCopyJob.isTraining,
      selectedTraining: item,
    });
  };

  const handleQuerySave = (data, cancelledBy, params) => {
    const idsField = isTraining ? "trainingIds" : "rotaCarerDateIds";
    let parameter = {
      [idsField]: params?.id ? [params?.id] : [],
      statusReason: data,
      cancelledBy: cancelledBy,
    };

    const confirmMessage = isTraining ? "Do you want to cancel this Training?" : "Do you want to cancel this Rota?";
    const successMessage = isTraining
      ? "Training has been cancelled successfully"
      : "Rota has been cancelled successfully";

    ConfirmationAlert("Are you sure!", confirmMessage, () => {
      const apiToCall = isTraining ? trainingCancelAPI : timesheetCancel;
      apiToCall(parameter, (_, error) => {
        if (error === null) {
          showSuccessToast(successMessage);
        } else {
          showErrorToast(error.message);
        }
        setQueryModal(false);
        close(ModalStatus.success);
      });
    });
  };

  return (
    <>
      <AnnsModal
        size={"md"}
        isOpen={visible}
        toggle={() => close(ModalStatus.pending)}
        title={isTraining ? "Training Detail" : "Rota Detail"}
        onCancelRota={
          item?.status === RotaOptions.cancelled || item?.status === RotaOptions.completed ? "" : onCancelRota
        }
        onEdit={
          item?.status !== RotaOptions.cancelled && item?.status !== RotaOptions.completed && item?.isTraining
            ? () => onEditTraining()
            : undefined
        }
        isFooterHide={true}
      >
        <Row className=" gy-2">
          <Col size="6">
            <span className="fw-bold">{isTraining ? "Training Title" : "Client"}</span>
            <span className="sub-text">{isTraining ? item?.title : item?.client?.name ?? "-"}</span>
          </Col>
          <Col size="6">
            <span className="fw-bold">Carer</span>
            <span className="sub-text">{item?.carer ?? "-"}</span>
          </Col>
          {isTraining ? (
            <Col size="6">
              <span className="fw-bold">Start Date</span>
              <span className="sub-text">{item?.startDate ? dateToShow(item?.startDate) : "-"}</span>
            </Col>
          ) : (
            <Col size="6">
              <span className="fw-bold">Ward</span>
              <span className="sub-text">{item?.wardData?.wardName ?? "-"}</span>
            </Col>
          )}
          <Col size="6">
            <span className="fw-bold">Start Time - End Time</span>
            <span className="sub-text">
              {moment(item?.startTime).format("HH:mm")} - {moment(item?.endTime).format("HH:mm") ?? "-"}
            </span>
          </Col>
          {isTraining ? (
            <Col size="12">
              <span className="fw-bold">Description</span>
              <span className="sub-text">{item?.desc ?? "-"}</span>
            </Col>
          ) : (
            <>
              <Col size="6">
                <span className="fw-bold">Rota Date</span>
                <span className="sub-text">{item?.rotaDate ? dateToShow(item?.rotaDate) : "-"}</span>
              </Col>
              <Col size="6">
                <span className="fw-bold">Day</span>
                <span className="sub-text">{item?.dayName ?? "-"}</span>
              </Col>
            </>
          )}
          {rotaStatus === RotaOptions.cancelled && (
            <>
              <Col size="6">
                <span className="fw-bold">Cancelled By</span>
                <span className="sub-text">{item?.lastModifiedBy}</span>
              </Col>
              <Col size="6">
                <span className="fw-bold">Cancelled Date</span>
                <span className="sub-text">{item?.lastModifiedDate}</span>
              </Col>
            </>
          )}
        </Row>
      </AnnsModal>
      <QueryModal
        isCancelReason
        visible={queryModal}
        isTraining={item?.isTraining}
        onClosed={() => {
          setQueryModal(false);
        }}
        onSaved={(data, cancelledBy) => handleQuerySave(data, cancelledBy, item)}
      />
    </>
  );
};

export default RotaDetailModal;
